document.addEventListener("turbo:load", () => {
  if (!document.querySelector("[data-react-class]")) return

  import(
    /* webpackChunkName: "react_rails_service" */ "../services/react_rails_service"
  ).then(({ ReactRailsUJS }) => {
    ReactRailsUJS.mountComponents()
  });
});
